<template>
  <a ref="link" class="link" :href="link"  
    :style="{
      opacity : skip ? 0 : 1,
  }" target="_blank">
    <img
      :style="{
        opacity: image ? 1 : 0,
        animationDelay: Math.random() + 's',
      }"
      ref="img"
      :src="image"
    />
    <span ref="span">{{ name }}</span>
  </a>
</template>
<script>
export default {
  props: ["id", "image", "link", "name","skip"],
  data() {
    return {
      cachedWidth: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.applyStyle();
    });
    window.addEventListener("resize", () => {
      this.applyStyle();
    });
  },
  methods: {
    applyStyle() {
      let span = this.$refs.span;
      let link = this.$refs.link;
      let spanWidth = this.cachedWidth || span.getBoundingClientRect().width;
      let linkWidth = link.getBoundingClientRect().width;
      this.cachedWidth = spanWidth;
      let scaleFactor = linkWidth / spanWidth;

      span.style.transform = "scaleX(" + scaleFactor + ")";
    },
  },
};
</script>
<style lang="scss" scoped>
.link {
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  color: white;
  text-decoration: none;
  height: 80px;
  position: relative;
  &:not(:last-child) {
    border-bottom: 1px solid white;
  }
  span {
    width: fit-content;
    transform-origin: left;
  }
  img {
    position: absolute;
    height: 80px;
    width: 80px;
    object-fit: contain;
    z-index: 1;
    animation: faccine 3s infinite;

    @keyframes faccine {
      0% {
        transform: translateX(0vw);
      }
      50% {
        transform: translateX(calc(100vw - 100% - 20px));
      }
      100% {
        transform: translateX(0vw);
      }
    }
  }
}
</style>